




import React, { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";
import StorefrontIcon from "@mui/icons-material/Storefront";
import styled from "@emotion/styled";
// import ProsperityCard from "../../../../../Components/ProsperityCard/ProsperityCard";
import Pusrchase_GoldStakeCard from "../../../../../Components/Pusrchase_GoldStakeCard/Pusrchase_GoldStakeCard";
import puschasegoldCardIcon from "../../../../../Assets/gold_puschased_icon.svg"
import actions from "../../../../../ReduxStore/actions";
import { useDispatch, useSelector } from "react-redux";
import ModalApproveButton from "../../../../../Components/ModalButton/HomeSectionButton/ModalApproveButton";
const DashedArrow = styled("div")(() => ({
    position: "absolute",
    borderTop: "2px dashed black",
    width: "calc(33% - 40px)", // Adjust the width for proper spacing
    top: "50%",
    transform: "translateY(-50%)",
    left: "calc(33% - 20px)", // Adjust for spacing between cards
    "&:after": {
        content: '""',
        position: "absolute",
        top: "-6px",
        right: "-12px",
        width: "0",
        height: "0",
        borderLeft: "8px solid transparent",
        borderRight: "8px solid transparent",
        borderTop: "8px solid black",
    },
}));

const Pusrchase_GoldStake = ({ stakeNowDates, values, sectionNameForApproveAndReject, onClose }) => {


    const [responseData, setResponseData] = useState()

    console.log(values, "valuesssss")
    console.log(responseData, "responseDatattaatatatt")
    const TableId = useSelector((state) => state.Table.TableId);

    console.log(TableId, "TebleIddddd")

    const dispatch = useDispatch()

    useEffect(() => {
        console.log(TableId, "TebleIddddd111")

        if (TableId && !values) {
            console.log(TableId, "TebleIddddd222")

            const fetchData = async () => {
                const data1 = {
                    data: {},
                    method: "get",
                    apiName: `getStakeNowSectionById/${TableId}`,
                };
                const response = await dispatch(actions.GETSTAKENOWSECTIONBYID(data1));

                console.log(response, "responseresponse")

                if (response?.payload?.message === "Stake Now section retrieved successfully.") {
                    console.log("hiiii")

                    setResponseData(response?.payload?.data)
                    // setUploadedFile({
                    //     fileUrl: response?.payload?.data.additional_data[0]?.banner,
                    //     type: "img",
                    //     progress: 100,
                    // }
                    // )
                    // console.log(response?.payload?.data.additional_data[0]?.banner,"yhfuwrfrkjrw")
                }
            };
            fetchData();
        }

    }, []);


    const steps = values ? values?.cards?.map((data) => ({
        logo: data?.image?.fileUrl,
        title: data?.card_title,
        content: data?.card_content
    })) : (responseData?.additional_data?.card_design?.map((data) => ({
        logo: data?.logo,
        title: data?.title,
        content: data?.content
    })))

    const steps1 = responseData?.additional_data?.card_design || values?.cards || [
        {
            title: "Lorem Ipsum",
            content:
                "Lorem Ipsum is simply dummy text of the printing and typesetting in Lorem Ipsum has been the industrys standard dummy text ever since the 1500s when an unknown printer took a galley of type.",
            logo: puschasegoldCardIcon,
        },
        {
            title: "Lorem Ipsum",
            content:
                "Lorem Ipsum is simply dummy text of the printing and typesetting in Lorem Ipsum has been the industrys standard dummy text ever since the 1500s when an unknown printer took a galley of type.",

            // "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s",
            logo: puschasegoldCardIcon,
        },
        {
            title: "Lorem Ipsum",
            content:
                "Lorem Ipsum is simply dummy text of the printing and typesetting in Lorem Ipsum has been the industrys standard dummy text ever since the 1500s when an unknown printer took a galley of type.",

            // "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s",
            logo: puschasegoldCardIcon,
        },
        {
            title: "Lorem Ipsum",
            content:
                "Lorem Ipsum is simply dummy text of the printing and typesetting in Lorem Ipsum has been the industrys standard dummy text ever since the 1500s when an unknown printer took a galley of type.",

            // "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s",
            logo: puschasegoldCardIcon,
        },
        {
            title: "Lorem Ipsum",
            content:
                "Lorem Ipsum is simply dummy text of the printing and typesetting in Lorem Ipsum has been the industrys standard dummy text ever since the 1500s when an unknown printer took a galley of type.",

            // "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s",
            logo: puschasegoldCardIcon,
        },
        {
            title: "Lorem Ipsum",
            content:
                "Lorem Ipsum is simply dummy text of the printing and typesetting in Lorem Ipsum has been the industrys standard dummy text ever since the 1500s when an unknown printer took a galley of type.",

            // "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s",
            logo: puschasegoldCardIcon,
        },
    ];

    return (
        <>
            <Box sx={{ p: 4 }}>
                <Box sx={{ textAlign: "center", mb: 4 }}>
                    <Typography
                        variant="h3"
                        gutterBottom
                        sx={{ paddingBottom: "5px" }}
                    >
                        {/* {stakeNowDates?.[0]?.heading || "Default Heading"} */}
                        {values?.heading_title || responseData?.heading || "Default Heading"}
                        <span style={{ color: "black", fontWeight: "800" }}>
                            {/* {stakeNowDates?.[0]?.sub_heading || "Default Sub-heading"} */}
                            &nbsp; {responseData?.sub_heading || values?.heading_second_text || "Default Sub-heading"}
                        </span>
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            paddingBottom: "5px",
                            maxWidth: "900px",
                            margin: "0 auto",
                            textAlign: "center",
                            color: "#b0aaaa",

                        }}
                    >
                        {/* {stakeNowDates?.[0]?.content || "Default Content"} */}
                        {values?.heading_sub_text || responseData?.content || "Default Content"}


                    </Typography>
                </Box>

                {/* <Box sx={{ position: "relative", display: "flex", justifyContent: "space-between" }}>
          <Grid container justifyContent="center" spacing={4} alignItems="center">
            {steps.map((item, index) => (
              <Grid item xs={12} sm={4} key={index}>
                <ProsperityCard
                  icon={item.icon}
                  title={item.title}
                  description={item.description}
                />
                <Box sx={{ border: "1px dashed red" }}> </Box>

              </Grid>

            ))}
          </Grid> */}
                <Box sx={{ position: "relative", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Grid container justifyContent="center" spacing={6} alignItems="center">
                        {steps?.map((item, index) => (
                            <Grid item xs={12} sm={4} key={index} sx={{ position: "relative" }}>
                                <Pusrchase_GoldStakeCard
                                    //  icon={item.logo}
                                    icon={item?.logo}

                                    title={item?.title}
                                    description={item?.content}
                                />
                                {/* Curved Arrow */}
                                {/* {index < steps.length - 1 && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%", // Center vertically
                      right: "-50px", // Adjust based on curve size
                      width: "100px", // Width of the arrow
                      height: "50px", // Height of the curve
                      border: "none",
                      borderTop: "2px dashed #ccc", // Dashed line
                      borderRadius: "50%", // Makes it curved
                      transform: "translateY(-50%)",
                      zIndex: -1,
                    }}
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        right: "-10px", // Position for arrowhead
                        width: "0",
                        height: "0",
                        borderLeft: "6px solid #ccc",
                        borderTop: "6px solid transparent",
                        borderBottom: "6px solid transparent",
                        transform: "rotate(45deg)",
                      }}
                    />
                  </Box>
                )} */}
                            </Grid>
                        ))}
                    </Grid>
                </Box>


                {/* Add the dashed arrows between the cards */}
                {/* {steps.slice(0, -1).map((_, index) => (
            <DashedArrow key={index} style={{ left: `${(index + 1) * 33.33}%` }} />
          ))} */}
                {/* </Box> */}
            </Box>
            <ModalApproveButton approveStatus={responseData?.approval_status} values={values} onClose={onClose} sectionNameForApproveAndReject={sectionNameForApproveAndReject} />
        </>
    );
};

export default Pusrchase_GoldStake;
